import { injectAsyncReducer } from '@lingoda/core';
import { STORE_KEY } from './constants';
import reducers from './reducers';
import initSideEffects from './side-effects';

export * from './models';
export * from './utils';
export * from './selectors';
export * from './hooks';
export * from './actions';
export * from './components';
export * from './hoc';

injectAsyncReducer(STORE_KEY, reducers);
initSideEffects();
